"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TitleWrapper = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        maxWidth: '100%',
        gap: theme.spacing(3),
        margin: theme.spacing(0, 'auto'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            maxWidth: 985,
            gap: theme.spacing(6)
        }
    };
});
const TitleWrapper = exports.TitleWrapper = (0, _mui.styled)('div')(()=>({
        maxWidth: 600
    }));
